module.exports = __webpack_public_path__ + "img/whiteAddbtn.e5ae6280.svg";